import { useSelector } from 'react-redux';

import { useGetSubscriptionCurrencyCode } from './use-get-subscription-currency-code';
import { ADD_USER } from '../../../../constants/features';
import Global from '../../../../store/global-selectors';
import { DEFAULT_USER_ADDON_PRICE } from '../components/manage-subscription-drawer/constants';

// TODO: https://auctane.atlassian.net/browse/SPD-18331 Prune excess user addon representations. Convert it to first class addOn interface.
// NOTE: See above ticket for state paths that we do not use anymore. Anything outside of this hook should be considered deprecated.
// Use this hook as source of truth.
export const useGetUserSeatsAddOnData = () => {
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const planInfo = useSelector(Global.selectSellerPlanInfo);
  const { currentSubscription = {}, currentBillingPlan } = subscriptionData;
  // TODO: Remove. This is old and at time of writing only contains users. https://auctane.atlassian.net/browse/SPD-18331
  const addOns = currentSubscription.billingAddOns || [];
  const extraUserAddon = addOns.find((addon) => addon.code === ADD_USER);

  const additionalUsersReference = planInfo?.additionalUsers;
  const additionalUsersCost = additionalUsersReference?.cost;
  const currencyCode = useGetSubscriptionCurrencyCode();

  const addonData = {
    unitCost: {
      value: currentBillingPlan?.userAddOnPrice?.value ?? DEFAULT_USER_ADDON_PRICE,
      code: currencyCode,
    },
    quantity: extraUserAddon?.quantity ?? additionalUsersCost?.quantity ?? 0,
  };

  return addonData;
};
